export abstract class BaseAdapter<TSource, TDest> {
	public adaptMany(items: TSource[], args?: unknown): TDest[] {
		return items?.map((item: TSource) => this.adapt(item, args));
	}

	public abstract adapt(item: TSource, args?: unknown): TDest;
}

export interface BaseAdapterI<TSource, TDest> {
	adaptMany(items: TSource[], args?: unknown): TDest[];
	adapt(item: TSource, args?: unknown): TDest;
}
